import { useQuery } from "@tanstack/react-query";

import { getlastImages } from "../../api/queries";

export const useLastImages = () => useQuery(["lastImages"], getlastImages);
